export interface TransferModelValue {
  there: DirectionModelValue;
  back: DirectionModelValue;
}

export interface DirectionModelValue {
  type: DirectionType | null;
  option: DirectionOption | null;
  price?: number;
}

export enum DirectionType {
  Public = 'public',
  Group = 'group',
  Individual = 'individual',
}

export enum DirectionOption {
  Economy = 'economy',
  Comfort = 'comfort',
  Business = 'business',
  Premium = 'premium',
  Limousine = 'limousine',
  SUV = 'suv',
  Van = 'van',
  Minibus = 'minibus',
  Bus = 'bus',
  Helicopter = 'helicopter',
  Boat = 'boat',
}

export interface Point {
  type: PointType;
  title: string;
}

export enum PointType {
  Airport = 'airport',
  Hotel = 'hotel',
}

export enum Direction {
  There = 'there',
  Back = 'back',
}

export enum Capacity {
  Adult = 'adult',
  Children = 'children',
  Luggage = 'luggage',
}

export interface Type {
  value: DirectionType;
  price?: number;
  includedInPrice?: boolean;
  disabled?: boolean;
  loading?: boolean;
  duration?: string;
  distance?: string;
}

export interface Passengers {
  adultsCount: number;
  childrenCount?: number;
  childrenAge?: number[];
}

export interface Option {
  value: DirectionOption;
  price: number;
  adultCount: number;
  luggageCount: number;
  childrenCount: number;
  includedInPrice?: boolean;
}

export enum ChildrenAge {
  Infant = 'infant',
  Child = 'child',
  Teenager = 'teenager',
}
